import { getSupervisors, getEmployeeTimesheet, getUnsubmittedEmployeeTimesheet } from "../api/supervisorList";
import { TimesheetType } from "../interfaces/TimesheetInterface";

// Function to grab the list of supervisors based on pay period ID and type
const grabSupervisors = async (payPeriodID: number, type: TimesheetType, adminUserEmployeeID?: number): Promise<any> => {

    try {
        // Make the API request to get the list of supervisors
        const apiResults = await getSupervisors(payPeriodID, type, adminUserEmployeeID);

        // Check if the API results are not returned or empty, throw an error
        if (!apiResults) { 
            throw new Error("Login Failed.");
        }

        // Store the results from the API response
        const authData = apiResults;

        // Return the authData to be used elsewhere
        return authData;

    } catch (err) {
        // Log any errors encountered during the fetch of supervisors
        console.error("Error in performLogin", err);

        // Throw the error for handling in calling code
        throw err;
    }

};

const grabUnsubmittedEmployeeTimesheet = async (employeeID: number, payPeriodID: number): Promise<any> => {
    try {
        const apiResults = await getUnsubmittedEmployeeTimesheet(employeeID, payPeriodID);

        if (!apiResults) { 
            throw new Error("Grabbing Timesheet Failed.");
        }

        const employeeTimesheet = apiResults;
        return employeeTimesheet;
    } catch (err) {
        // Log any errors encountered during the fetch of supervisors
        console.error("Error in getEmployeeTimesheet", err);

        // Throw the error for handling in calling code
        throw err;
    }
};

const grabEmployeeTimesheet = async (employeeID: number, payPeriodID: number): Promise<any> => {
    try {
        const apiResults = await getEmployeeTimesheet(employeeID, payPeriodID);

        if (!apiResults) { 
            throw new Error("Grabbing Timesheet Failed.");
        }

        const employeeTimesheet = apiResults;
        return employeeTimesheet;
    } catch (err) {
        // Log any errors encountered during the fetch of supervisors
        console.error("Error in getEmployeeTimesheet", err);

        // Throw the error for handling in calling code
        throw err;
    }
};

// Export the grabSupervisors function to be used in other parts of the application
export { grabSupervisors, grabUnsubmittedEmployeeTimesheet, grabEmployeeTimesheet };
